import useTranslate from '@hooks/useTranslate';
import modals, { closeModal } from '@stores/modals';

import { DatePicker, Form, Modal } from 'antd';
import { FunctionComponent } from 'react';
import modalContent from '../UserInfo.content.json';
import { useForm } from 'antd/lib/form/Form';
import moment, { Moment } from 'moment';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import IUser from '@interfaces/IUser';
import { useParams } from 'react-router';
import { continuePlus, getIsPlus, getItem } from '@stores/user';
import { useStore } from 'effector-react';
// eslint-disable-next-line no-duplicate-imports
interface ContinuePlusValue {
  startDate: Date;
  endDate: Date;
  accountId: IUser['id'];
  date: [Moment, Moment];
}
dayjs.extend(customParseFormat);

const UserContinuePlusModal: FunctionComponent = () => {
  const { userId } = useParams<{ userId: IUser['id'] }>();
  const content = useTranslate(modalContent);
  const [form] = useForm();
  const onFinish = async (values: ContinuePlusValue) => {
    const dataRequest = {
      endDate: moment(values.date[1]).format(),
      accountId: userId,
    };
    await continuePlus(dataRequest);
    await closeModal({ name: 'continuePlus' });
    await getItem({ userId: userId }).then(() => getIsPlus({ userId }));
  };

  const { data } = useStore(modals);

  return (
    <Modal
      title={content.gameramPlusContinue}
      visible
      onCancel={() => closeModal({ name: 'continuePlus' })}
      onOk={() => form.submit()}
    >
      <Form
        onFinish={onFinish}
        form={form}
        initialValues={{
          date: [
            data?.plusDefaultStartDate ? moment(data.plusDefaultStartDate) : moment(),
            moment(data.plusDefaultStartDate).add(7, 'day'),
          ],
        }}
      >
        <Form.Item
          name='date'
          style={{ padding: 0, margin: 0 }}
        >
          <DatePicker.RangePicker
            disabled={[true, false]}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UserContinuePlusModal;
